// src/components/Footer.js

import React from 'react';
import './Footer.css'; // Import the CSS specific to the footer
import { Link } from 'react-router-dom';


function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Términos & Condiciones</h3>
          <ul>
          <li><Link to="/terminos-condiciones">Términos y Condiciones</Link></li>
          <li><Link to="/politica-entrega">Política de Entrega</Link></li>
          <li><Link to="/politica-devoluciones">Política de Devoluciones y Cancelaciones</Link></li>
          <li><Link to="/politica-privacidad">Política de Uso y Privacidad</Link></li>
          <li><Link to="/politica-seguridad">Política de Seguridad</Link></li>
          </ul>
        </div>
       {/* 
        <div className="footer-section">
          <h3>Servicio al cliente</h3>
          <ul>
            <li><a href="#">Contáctanos</a></li>
            <li><a href="#">Preguntas frecuentes</a></li>
            <li><a href="#">Acceso Administrativo</a></li>
          </ul>
        </div> 
        */}
        <div className="footer-section">
          <h3>Síguenos en:</h3>
          <div className="social-icons">
            <a href="https://www.instagram.com/santodomingoespectaculos" target="_blank" rel="noopener noreferrer"><img src="/images/ig.png" alt="Instagram" /></a>
            <a href="https://www.facebook.com/santodomingoespectaculos" target="_blank" rel="noopener noreferrer"><img src="/images/fac.png" alt="Facebook" /></a>
            <a href="https://www.twitter.com/santodomingoesp" target="_blank" rel="noopener noreferrer"><img src="/images/x.jpeg" alt="X" /></a>
            <a href="https://www.threads.com/@santodomingoespectaculos" target="_blank" rel="noopener noreferrer"><img src="/images/thread.png" alt="Threads" /></a>
            <a href="https://www.youtube.com/@SantoDomingoEspectaculos" target="_blank" rel="noopener noreferrer"><img src="/images/youtube.png" alt="YouTube" /></a>
            <a href="https://www.tiktok.com/@santo.domingo.esp" target="_blank" rel="noopener noreferrer"><img src="/images/tiktok.png" alt="TikTok" /></a>
          </div>
        </div>
        <div className="footer-section payment-section">
          <h3>Powered by</h3>
          <img src="/images/paypal.jpg" alt="Paypal" />
          <div className="payment-icons">
            <img src="/images/visa.png" alt="Visa" />
            <img src="/images/mastercard.png" alt="MasterCard" />
            <img src="/images/american.png" alt="American Express" />
          </div>
          
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2025 SantoDomingoEspectaculos.com Todos los derechos reservados</p>
        <a href="https://wa.me/18496509878" className="whatsapp-button" target="_blank" rel="noopener noreferrer">
          <img src="/images/whatsapp.png" alt="WhatsApp" />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
